<main>
    <div class="container-fluid site-width">
        <div class="row">
            <div class="col-12  align-self-center">
                <div class="sub-header mt-3 py-3 align-self-center d-sm-flex w-100 rounded">
                    <div class="w-sm-100 me-auto">
                        <h4 class="mb-1">Resumen de servicios</h4>
                        <p class="mb-0 my-auto text-muted font-w-500 tx-s-12">Bienvenido(a) a la Agencia Virtual de la
                            Sociedad de Seguros de Vida del Magisterio Nacional. En esta sección se muestran
                            todos aquellos servicios que hemos puesto a su disposición.</p>
                    </div>

                    <ol class="breadcrumb bg-transparent align-self-center m-0 p-0">
                        <li class="breadcrumb-item"><a href="javascript:void(0);">Inicio</a></li>
                        <li class="breadcrumb-item active">Resumen de servicios</li>
                    </ol>
                </div>
            </div>
        </div>
        <!-- <div class="row">
            <div class="col-12 mt-3">
                <div class="d-md-flex">
                    <p class="mb-0 my-auto text-muted font-w-500 tx-s-12">Bienvenido(a) a la Agencia Virtual de la
                        Sociedad de Seguros de Vida del Magisterio Nacional. En esta sección se muestran
                        todos aquellos servicios que hemos puesto a su disposición.</p>
                </div>
            </div>
        </div> -->
        <div class="row">
            <div class="col-7 mt-3 inner-contents">
                <div class="p-2">
                    <div class="d-flex mt-4">
                        <a routerLink="/home/view/AC_VI99"
                            class="border-0 outline-bg-primary w-50 p-3 rounded text-center index-anchor">
                            <i class="icon-doc" style="font-size: 30px;"></i>
                            <br />
                            <br />
                            <span class="h6 mb-0">Estado de cuenta</span>
                            <br />
                            <br />
                            Visualice y descargue su estado de cuenta<br />
                            para su mayor comodidad
                            <br />
                            <br />
                        </a>
                        <a routerLink="/home/view/AC_VI01"
                            class="border-0 outline-badge-info w-50 p-3 rounded me-2 text-center index-anchor">
                            <i class="icon-pencil" style="font-size: 30px;"></i>
                            <br />
                            <br />
                            <span class="h6 mb-0">Actualización y verificación de datos</span>
                            <br />
                            <br />
                            Actualice su información personal para mejorar<br />
                            la atención que le brindamos
                            <br />
                            <br />
                        </a>
                    </div>
                </div>
            </div>
            <div class="col-5"></div>
        </div>
    </div>
</main>